import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import {  ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { ProxyService } from 'src/app/services/proxy.service';
import { AlertComponent } from 'src/app/structure/alert/alert.component';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-proxylist',
  templateUrl: './proxylist.component.html',
  styleUrls: ['./proxylist.component.css']
})
export class ProxylistComponent implements OnInit {

  public environmentSettings: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfProxy: DataTables.Settings = {};
  registerProxyList: any[];
  editproxyId: any;
  masterDirectorList: any[];
  folioNumber: any[];
  dtTriggerProxy: Subject<any> = new Subject();
  dtTriggerRegisterDirector: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  currentURL: any;
  response: boolean;
  deleteProxyId: any;
  searchByFolioNumber: any;
  dateOfReceiptOfProxy: any;
  dateOfReceiptOfProxyTo: any;
  futureToDate: NgbDateStruct;
  futureFromDate: NgbDateStruct;
  isSearchDivVisible = false;

  constructor(private proxyService: ProxyService, private router: Router, private commonFunction: CommonFunction,
     private alert: AlertComponent,private activatedRoute: ActivatedRoute ) {
    this.response = false;
  }

  ngOnInit() {
    this.environmentSettings = environment;
    let searchflag = localStorage.getItem('searchdireflag');

    this.getProxiesList();
    this.dtOptionsOfProxy = {
      destroy: true,
      scrollX: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [5] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Proxy',
          title: 'Proxy',
          extend: 'excel',
          exportOptions: {
            columns: [0,1,2,4],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }
        }
      ]
    };

    // this.currentURL = window.location.href;
    // var haseditpermisssion: any = false;
    // if (this.currentURL.includes('edit') && !environment.PSS) {
    //   haseditpermisssion = this.commonFunction.validateURL('Director', 'edit');
    // }
    // else if (environment.PSS) {
    //   haseditpermisssion = this.commonFunction.validateURL('Director', 'add');
    // }
    // haseditpermisssion = false;
  }
  add(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['proxy','add']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  adjustdirectormasterTable() {
    var directorData = this.registerProxyList;
    if (directorData.length) {
      this.registerProxyList = [];
      $("#proxymasterTable").DataTable().destroy();
      this.registerProxyList = directorData;
      this.dtTriggerProxy.next();
      setTimeout(() => {
        $("#proxymasterTable").DataTable().columns.adjust().draw();
      }, 200);
    }
  }

  tabRegisterOfDirectorOnClickEvent() {
    setTimeout(() => {
      $("#proxymasterTable").DataTable().columns.adjust().draw();
    });
  }

  getProxiesList() {
    this.registerProxyList = [];
    this.proxyService.getAllProxyDetails({ isSearch: false }).subscribe(registerList => {
      this.registerProxyList = registerList.data;
      this.dtTriggerProxy.next();
    });
  }

  editproxy(_id) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['proxy','edit',_id]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['proxy/edit/', _id]);
  }
  
  generateOutput() {
    let companyName = JSON.parse(localStorage.getItem('companyDetails')).companyName;
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {
      id: null,
      fromDate: this.dateOfReceiptOfProxy, 
      toDate: this.dateOfReceiptOfProxyTo,
      folioNumber: this.searchByFolioNumber
    }
    this.proxyService.generateProxyDocument(object).subscribe(response => {
      console.log(response)
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    console.log('Downloading')
    this.proxyService.downloadProxyFile(id, 'Multi');
  }
  downloadPdfDocument(id) {
    console.log('Downloading')
    this.proxyService.downloadProxyPdfFile(id, 'Multi');
  }
  confirmDelete(id) {
    this.deleteProxyId = id;
    $("#deleteConfirm").modal('toggle');
  }

  deleteProxies() {
    this.proxyService.removeproxydetails(this.deleteProxyId)
      .subscribe(response => {
        if (response.status == 0) {
          $("#proxymasterTable").DataTable().destroy();
          this.getProxiesList();
          this.alert.success(response.message);
          // $("#deleteConfirm").modal('toggle');
        } else {
          this.alert.error(response.message);
        }
      });
  }
  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  doAdvSearch() {
    this.response = true;

    var searchParam =
    {
      "folioNumber": this.searchByFolioNumber,
      "dateOfReceiptOfProxy": this.setDate(this.dateOfReceiptOfProxy),
      "dateOfReceiptOfProxyTo": this.setDate(this.dateOfReceiptOfProxyTo),
      'isSearch': true,
    };
    this.registerProxyList = [];
    $("#proxymasterTable").DataTable().destroy();
    this.proxyService.getAllProxyDetails(searchParam).subscribe(registerList => {
      this.response = false;

      this.registerProxyList = registerList.data;
      this.dtTriggerProxy.next();
    });
  }
  clearAdvSearch() {
    this.searchByFolioNumber = '';
    this.dateOfReceiptOfProxy = undefined;
    this.dateOfReceiptOfProxyTo = undefined;
    $("#proxymasterTable").DataTable().destroy();
    this.getProxiesList();

    this.response = false;

  }
}
